import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { BookingSession, RoomType, RoomTypeResult, TemporaryRoomTypeSelection } from "../../../Models";
import RoomSearchCriteria from "../../../states/RoomSearchCriteria";
import LightBox from "../../common/lightbox/LightBox";
import { Dialog, SvgIcon } from "../../common/MaterialDesignComponents";
import RoomTypeResultComponent from '../../desktop/roomselection/RoomTypeResultComponent';
import SelectedRoomListItemComponent from "../../common/roomselection/SelectedRoomListItemComponent";
import RoomDetailsComponent from "../roomDetails/RoomDetailsComponent";
import '../roomselection/RoomSelectionPage.css'

interface Attrs {  
    searchCriteria?: RoomSearchCriteria,  
    bookingSession?: BookingSession,
    messageProvider: MessageProvider,
    roomTypes: RoomType[],
    roomTypeResults?: RoomTypeResult[],
    selectedRoomSelections?: TemporaryRoomTypeSelection[],
    attemptingBackNav:boolean,
    onCheckoutRequested: (roomTypeSelections:TemporaryRoomTypeSelection[]) => void;
    onOptionSelected: (selection:TemporaryRoomTypeSelection) => void;
    onOptionRemoved: (selection:TemporaryRoomTypeSelection) => void;
    onChangeAttemptingBackNav: () => void;
    onBackPressed: () => void;
}
interface PhotoGalleryDialogOpen {
    photoUrls:string[]
}
type PhotoGalleryDialogState = 'hidden' | PhotoGalleryDialogOpen;

function RoomSelectionComponent(): m.Component<Attrs> {
    let showingWarningDialog = false;
    let showingCheckOutDialog = false;
    let photoGalleryDialogState:PhotoGalleryDialogState = 'hidden';

    function getNumberOfRoomTypeCount(roomTypeResult: RoomTypeResult, roomTypeSelections: TemporaryRoomTypeSelection[]){
        let filterRoomTypeSelected: TemporaryRoomTypeSelection[] = roomTypeSelections.filter(roomTypeSelection => 
            roomTypeSelection.roomType.id == roomTypeResult.roomType.id);
        return filterRoomTypeSelected.length;
    }

    function getTotalAvailableRoomCount(roomTypeResults: RoomTypeResult[]){
        let availableRoomCount = 0;
        roomTypeResults.forEach(roomTypeResult => availableRoomCount += roomTypeResult.bookableRoomQuantity);
        return availableRoomCount;
    }

    return {
        view(vnode) {    
            let {messageProvider, searchCriteria, roomTypeResults, bookingSession, roomTypes, selectedRoomSelections, attemptingBackNav, onBackPressed, onChangeAttemptingBackNav,
                onCheckoutRequested, onOptionRemoved, onOptionSelected} = vnode.attrs;

            return m("div",
            m("div.row",
            m("div.col-md-7",
                (roomTypeResults)?
                    roomTypeResults.map(roomTypeResult =>
                        m("div.mb-3",
                            m(RoomTypeResultComponent, {
                                numberOfRooms: searchCriteria?searchCriteria.getNumberOfRooms():0,
                                totalAvailableRoomCount: getTotalAvailableRoomCount(roomTypeResults!!),
                                roomTypeSelectedCount: getNumberOfRoomTypeCount(roomTypeResult, selectedRoomSelections!),
                                messageProvider: messageProvider,
                                roomTypeResult: roomTypeResult,
                                onOptionSelected: (roomTypeSelection:TemporaryRoomTypeSelection) => {
                                    if(searchCriteria?.getNumberOfRooms() == selectedRoomSelections!.length){
                                        showingCheckOutDialog = true;
                                    }else{
                                        showingCheckOutDialog = false;
                                        onOptionSelected(roomTypeSelection);
                                    }
                                },
                                onViewImagesSelected: (photos: string[]) => {
                                    photoGalleryDialogState = { photoUrls : photos };
                                },
                            })         
                        )
                    )
                :
                roomTypes.map(roomType =>
                    m("div.mb-3",
                        m(RoomDetailsComponent, {  
                            roomTypeSelectedCount: 0,
                            messageProvider: messageProvider,
                            roomType: roomType,
                            onViewImagesSelected: (photoUrls: string[]) => {
                                photoGalleryDialogState = { photoUrls : photoUrls };
                            },
                        })
                    )
                ),
                m(Dialog, {
                    isOpen: showingCheckOutDialog,
                    onClose : () => {
                        showingCheckOutDialog = false;
                    },
                    actionItems : [
                        {
                            label: "Close",
                            onclick: () => {
                                showingCheckOutDialog = false;
                            }
                        }
                    ]
                }, [
                    m("div.text-center", 
                        m(SvgIcon, {
                        iconType: "warning",
                        colorScheme: "warning",
                        sizeScheme: "largest"
                        })
                    ),
                    m("div", {class:"mb-1"}, messageProvider.get("warning_check_out_body"))
                ]),
                m(Dialog, {
                    isOpen: showingWarningDialog || attemptingBackNav,
                    onClose : () => {
                        showingWarningDialog = false;
                        onChangeAttemptingBackNav();
                    },
                    actionItems : [
                        {
                            label: "Cancel",
                            onclick: () => {
                                showingWarningDialog = false;
                                onChangeAttemptingBackNav();
                            }
                        },
                        {
                            label: "Ok",
                            onclick: () => {
                                showingWarningDialog = false;
                                onBackPressed();
                            }
                        }
                    ]
                }, [
                    m("div.text-center", 
                        m(SvgIcon, {
                        iconType: "warning",
                        colorScheme: "warning",
                        sizeScheme: "largest"
                        })
                    ),
                    m("div", {class:"mb-1"}, messageProvider.get("warning_cancel_guest_state"))
                ])           
            ),
            m("div.col-md-5", 
                m("div.card rounded-20", 
                    m("div.card-header rounded-top-20", messageProvider.get("selected_rooms")),
                    m("div.card-body", [
                        (selectedRoomSelections != undefined)?
                        selectedRoomSelections.map(tempRoomTypeSelection => 
                            m("div.my-2", 
                                m(SelectedRoomListItemComponent, {
                                    roomTypeSelection: tempRoomTypeSelection,
                                    messageProvider: messageProvider,
                                    onSelectionRemoved: (roomTypeSelection: TemporaryRoomTypeSelection) => {
                                        onOptionRemoved(roomTypeSelection);
                                    }
                                })
                            )                                
                        ):null,

                        searchCriteria?
                        (selectedRoomSelections!.length == 0)?
                        m("div.p-4 text-center text-muted", 
                        messageProvider.interpolate(searchCriteria.getNumberOfRooms()>1? "select_num_rooms" : "select_num_room", {count:searchCriteria.getNumberOfRooms()})): 
                        (selectedRoomSelections!.length != searchCriteria.getNumberOfRooms())?
                        m("div.p-4 text-center text-muted", 
                            messageProvider.interpolate(
                                searchCriteria.getNumberOfRooms() - selectedRoomSelections!.length>1 ? "select_num_more_room" : "select_num_more_rooms",
                                {"count":searchCriteria.getNumberOfRooms() - selectedRoomSelections!.length})):
                        null:
                        m("div.p-4 text-center text-muted", 
                                m("p",{
                                    class: messageProvider.getCurrentLang() == 'en'? "" : "mm-label-text"
                                },
                                messageProvider.get("search_to_select"))
                        ),
                        

                        m("div.mt-3", 
                            m("button", {
                                class: "btn btn-block btn-primary rounded",
                                disabled: searchCriteria && (searchCriteria.getNumberOfRooms() == selectedRoomSelections!.length)?
                                    false : "disabled",
                                onclick: (event) => {
                                    event.preventDefault();
                                    onCheckoutRequested([...selectedRoomSelections!]);
                                }
                            }, messageProvider.get("go_to_fill_guest_info"))
                        )
                    ])
                )
            
            ),
            m(LightBox, {
                imageUrls: (photoGalleryDialogState != 'hidden')?
                    (photoGalleryDialogState as PhotoGalleryDialogOpen).photoUrls : [],
                show: photoGalleryDialogState != 'hidden',
                onClose: () => {
                    photoGalleryDialogState = 'hidden';
                }
            }),
        )
        )
        }
    }
}

export default RoomSelectionComponent;

